import { render, staticRenderFns } from "./PasswordWithConfirmation.vue?vue&type=template&id=2cec33ce&scoped=true&"
import script from "./PasswordWithConfirmation.vue?vue&type=script&lang=ts&"
export * from "./PasswordWithConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordWithConfirmation.vue?vue&type=style&index=0&id=2cec33ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cec33ce",
  null
  
)

export default component.exports